import React, { useMemo } from "react";
import moment from "moment";
import {
    RenderKilogramo,
    RenderNumber,
} from "../../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../../Utils/renderField/nullableValue";

const eliminarIcon = require("assets/img/icons/borrar.png");

export const ProdReportadasTable = ({
    produccionesReportadas,
    EliminarEntrega,
    paletizacionCerrada,
}) => {
    const groupedData = useMemo(() => {
        const grouped = {};

        produccionesReportadas.forEach((item) => {
            const turno = item.turno_anterior
                ? "Turno anterior"
                : "Turno actual";

            const productoId =
                (item.producto_terminado && item.producto_terminado.id) || -1;

            if (!grouped[turno]) {
                grouped[turno] = {
                    totalKg: 0,
                    productos: {},
                };
            }

            const kgProduccion = parseFloat(item.kg_secos_pacas || 0);

            grouped[turno].totalKg += kgProduccion;

            if (!grouped[turno].productos[productoId]) {
                grouped[turno].productos[productoId] = {
                    id: productoId,
                    nombre: item.producto_terminado
                        ? item.producto_terminado.nombre
                        : "Sin producto",
                    padreNombre: item.producto_terminado
                        ? item.producto_terminado.padre_nombre
                        : null,
                    subtotalKg: 0,
                    entregas: [],
                };
            }

            grouped[turno].productos[productoId].subtotalKg += kgProduccion;
            grouped[turno].productos[productoId].entregas.push(item);
        });

        return grouped;
    }, [produccionesReportadas]);

    const totalPacas = produccionesReportadas.reduce(
        (sum, item) => sum + parseFloat(item.cantidad_pacas || 0),
        0,
    );

    const totalProduccion = produccionesReportadas.reduce(
        (sum, item) => sum + parseFloat(item.kg_secos_pacas || 0),
        0,
    );

    const turnosOrdenados = ["Turno actual", "Turno anterior"].filter(
        function (turno) {
            return groupedData[turno];
        },
    );

    return (
        <React.Fragment>
            <h5 className="mb-2">Entregas de producción a paletización</h5>

            <div className="new-table-wrapper prod-reportada__table-wrapper mx-auto">
                <table>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Cant. pacas producidas</th>
                            <th>Kg secos producidos</th>
                            {paletizacionCerrada ? (
                                <th style={{ paddingLeft: "3rem" }}></th>
                            ) : (
                                <th>Acciones</th>
                            )}
                        </tr>
                    </thead>

                    <tbody>
                        {produccionesReportadas.length === 0 && (
                            <tr>
                                <td colSpan={4} className="text-center">
                                    No hay envíos registrados
                                </td>
                            </tr>
                        )}

                        {turnosOrdenados.map((turno) => {
                            const turnoData = groupedData[turno];

                            const productosOrdenados = Object.values(
                                turnoData.productos,
                            ).sort(function (a, b) {
                                return a.nombre.localeCompare(b.nombre);
                            });

                            return (
                                <React.Fragment key={turno}>
                                    {/* Encabezado Turno */}
                                    <tr className="prod-reportada__turno-row">
                                        <td colSpan={4}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                }}
                                            >
                                                <span>{turno}</span>

                                                <span>
                                                    Total producido:{" "}
                                                    <RenderKilogramo
                                                        value={
                                                            turnoData.totalKg
                                                        }
                                                        decimals={3}
                                                    />
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    {productosOrdenados.map((productoData) => (
                                        <React.Fragment key={productoData.id}>
                                            {/* Encabezado Producto */}
                                            <tr
                                                className="prod-reportada__producto-row"
                                                style={{
                                                    borderTop: "1px solid #ddd",
                                                }}
                                            >
                                                <td
                                                    colSpan={4}
                                                    style={{
                                                        paddingLeft: "25px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent:
                                                                "space-between",
                                                        }}
                                                    >
                                                        <span>
                                                            {productoData.padreNombre
                                                                ? `${productoData.padreNombre} - ${productoData.nombre}`
                                                                : productoData.nombre}
                                                        </span>

                                                        <span>
                                                            Sub-total:{" "}
                                                            <RenderKilogramo
                                                                value={
                                                                    productoData.subtotalKg
                                                                }
                                                                decimals={3}
                                                            />
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>

                                            {/* Detalle */}
                                            {productoData.entregas.map(
                                                (prodReportada) => (
                                                    <tr key={prodReportada.id}>
                                                        <td className="text-center text-nowrap">
                                                            {prodReportada.fecha_con_desfase
                                                                ? moment(
                                                                      prodReportada.fecha_con_desfase,
                                                                  ).format(
                                                                      "DD/MM/YYYY HH:mm",
                                                                  )
                                                                : "—"}
                                                        </td>

                                                        <td className="text-center text-nowrap">
                                                            <RenderNumber
                                                                value={
                                                                    prodReportada.cantidad_pacas
                                                                }
                                                            />
                                                        </td>

                                                        <td className="text-center text-nowrap">
                                                            <NullableValue
                                                                value={
                                                                    prodReportada.kg_secos_pacas
                                                                }
                                                            >
                                                                <RenderKilogramo
                                                                    value={
                                                                        prodReportada.kg_secos_pacas
                                                                    }
                                                                    decimals={3}
                                                                />
                                                            </NullableValue>
                                                        </td>

                                                        <td className="text-center text-nowrap">
                                                            {!paletizacionCerrada && (
                                                                <div className="table-actions">
                                                                    <img
                                                                        src={
                                                                            eliminarIcon
                                                                        }
                                                                        alt="Eliminar"
                                                                        title="Eliminar"
                                                                        className="action_img"
                                                                        onClick={() =>
                                                                            EliminarEntrega(
                                                                                prodReportada.id,
                                                                            )
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ),
                                            )}
                                        </React.Fragment>
                                    ))}
                                </React.Fragment>
                            );
                        })}

                        {/* Totales Generales */}
                        {produccionesReportadas.length > 0 && (
                            <tr className="totales-row">
                                <td
                                    className="text-right"
                                    style={{
                                        fontWeight: "bold",
                                    }}
                                >
                                    Totales Generales
                                </td>

                                <td className="text-center">
                                    <RenderNumber
                                        value={totalPacas}
                                        decimals={3}
                                    />
                                </td>

                                <td className="text-center">
                                    <RenderKilogramo
                                        value={totalProduccion}
                                        decimals={3}
                                    />
                                </td>

                                <td />
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};
